import { createContext, useEffect, useState } from "react"

export const ThemeContext = createContext(null)

const useTheme = () => {
  const [theme, setTheme] = useState(localStorage.getItem("theme"))

  useEffect(() => {
    // Set html class with theme
    document.documentElement.classList.add(theme)

    // Set body class with bg and text colors
    document.body.className =
      theme === "dark" ? "dark:bg-stone-900 dark:text-neutral-200" : "bg-stone-300 text-stone-800"

    // save theme to local storage
    localStorage.setItem("theme", theme)

    // reset elements
    return () => {
      document.documentElement.className = ""
      document.body.className = ""
    }
  }, [theme])

  return [theme, setTheme]
}

export default useTheme
